import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { ISignatureImage } from "src/app/dc3-report/interfaces/signature-catalog.interface";

@Component({
  selector: "app-image-list",
  templateUrl: "./image-list.component.html",
  styleUrls: ["./image-list.component.css"],
})
export class ImageListComponent {
  @Input()
  public imageList: ISignatureImage[] = [];
  @Output()
  public deleteImageEmitter: EventEmitter<ISignatureImage> = new EventEmitter();
  protected imageIcon = faImage;
  // overlay
  public overlayImageUrl: SafeUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  getImageBase64Url(image: ISignatureImage): SafeUrl {
    const base64Url = `data:image/png;base64,${image.imagenBase64}`;
    return this.sanitizer.bypassSecurityTrustUrl(base64Url);
  }

  // overlay
  showOverlay(signatureImage: ISignatureImage, $event: Event) {
    $event.stopPropagation();
    this.overlayImageUrl = this.getImageBase64Url(signatureImage);
  }
  hideOverlay() {
    this.overlayImageUrl = null;
  }
  // delete image
  onDeleteImage(image: ISignatureImage) {
    this.deleteImageEmitter.emit(image);
  }
}
